/**
 * Listens for scroll on main layout surfaces (PerfectScrollbar `.main-scroll-container`
 * or `.c-body`) so "All entries" lazy pagination still fires when the user scrolls the
 * page shell rather than only the inner PS element.
 *
 * @param {() => void} onReachScrollEnd - Called when the user has scrolled to the bottom
 *   of a matching layout scroller (caller should guard loading / pagination).
 * @returns {() => void} Teardown function (call from `onUnmounted`).
 */
export function attachMainLayoutLazyScroll(onReachScrollEnd) {
  if (typeof onReachScrollEnd !== "function") {
    return () => {}
  }

  const THRESHOLD = 12
  const handler = (event) => {
    const el = event.target
    if (!el?.classList?.contains) {
      return
    }
    const isLayoutScroller =
      el.classList.contains("main-scroll-container") ||
      el.classList.contains("c-body")
    if (!isLayoutScroller) {
      return
    }
    if (el.clientHeight + el.scrollTop + THRESHOLD < el.scrollHeight) {
      return
    }
    onReachScrollEnd()
  }

  document.addEventListener("scroll", handler, { capture: true, passive: true })
  return () => {
    document.removeEventListener("scroll", handler, { capture: true })
  }
}
